module.exports = __webpack_public_path__ + "images/50a3bda.jpg";